import { apiClient } from './client';

export type CopilotMode = 'informational' | 'empathetic' | 'scheduling' | 'clinical' | 'followup';

export interface MacSuggestRequest {
  phone: string;
  conversation_id?: string;
  draft_text?: string;
  use_full_context?: boolean;
  patient_id?: string;
  intent?: string;
  mode?: CopilotMode | '';
  variants?: number;
}

export interface MacSuggestion {
  id: string;
  text: string;
  model?: string;
  mode?: string;
  generated_at?: string;
}

export interface MacSuggestResponse {
  status: 'ok' | 'mac_unavailable' | 'error';
  suggestions?: MacSuggestion[];
  suggestion?: string; // backward-compat
  context_sources?: string[];
  model_used?: string;
  latency_ms?: number;
  message?: string;
  event_id?: string;
}

export interface MacHistoryEvent {
  id: string;
  created_at: string;
  user_id?: string;
  mode: string;
  intent_text: string;
  variants_requested: number;
  selected_variant_text?: string;
  final_ai_source?: string | null;
  final_sent_message_id?: string | null;
  response_latency_ms?: number | null;
}

export interface MacHistoryResponse {
  events: MacHistoryEvent[];
}

export async function suggestReply(
  tenantId: string,
  req: MacSuggestRequest
): Promise<{ data: MacSuggestResponse; eventId: string | null }> {
  const response = await apiClient.post<MacSuggestResponse>('/mac/suggest', req, {
    headers: { 'X-Tenant-ID': tenantId },
  });
  const eventId = response.headers['x-mac-event-id'] ?? response.data.event_id ?? null;

  // Backward-compat: если MAC вернул старый формат — нормализуем в suggestions[]
  if (response.data.status === 'ok' && !response.data.suggestions?.length && response.data.suggestion) {
    response.data.suggestions = [{
      id: 'legacy_' + Date.now(),
      text: response.data.suggestion,
      mode: req.mode ?? '',
    }];
  }

  return { data: response.data, eventId };
}

export async function fetchMacHistory(
  tenantId: string,
  patientId: string,
  limit = 20
): Promise<MacHistoryResponse> {
  const { data } = await apiClient.get<MacHistoryResponse>('/mac/history', {
    headers: { 'X-Tenant-ID': tenantId },
    params: { patient_id: patientId, limit },
  });
  return data;
}
